<template>
  <el-dialog
    v-el-drag-dialog
    no="ReleaseGoodsJY"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.JyWarehouseApiLog')"
    :close-on-click-modal="false"
    width="1000px"
    @close="dialogClose"
  >
    <cargo-ag-grid
      config-module="2024032002"
      :grid-options="gridOptions"
      :grid-params.sync="gridParams"
      :column-defs="columnDefs"
      :row-data="rowData"
    />
    <div slot="footer">
      <el-button type="primary" @click="dialogClose()">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="dialogClose">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { jyWarehouseApiLog } from '@/api/booking/jyWarehouse'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'JyWarehouseApiLogDialog',
  props: {
    visible: { type: Boolean, default: false },
    data: { type: Object, default: null },
    jobUuid: { type: String, default: '' }
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      gridParams: {},
      gridOptions: {
        context: {
          componentParent: this
        }
      },
      rowData: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.InterfaceName'), field: 'logSource', colId: 'logSource', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.jyInterfaceLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.DataFlowDirection'),
          field: 'dataFlowDirection',
          colId: 'dataFlowDirection',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.apiDataFlowDirectionLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SendDate'), field: 'dateCreated', colId: 'dateCreated', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_PushMessage'), field: 'requestMsg', colId: 'requestMsg', flex: 1 },
        {
          headerName: this.$t('SeaExport.createdBy'), field: 'createdBy', colId: 'createdBy', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.RespMsg'), field: 'responseMsg', colId: 'responseMsg', flex: 1 }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (this.visible) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.onShow()
    }
  },
  methods: {
    dialogClose() {
      this.$emit('update:visible', false)
    },
    onShow() {
      this.rowData = []
      jyWarehouseApiLog({ jobUuid: this.jobUuid }).then(res => {
        this.rowData = res.data
      })
    }
  }
}
</script>

<style scoped>

</style>
